import Swal from "sweetalert2";
import { DetailBundling, ICart } from "../constants/types";

interface IQty {
    id: number;
    qty: number;
}

export default function validateStockBeforePayment(cart: ICart[]): boolean {
    const newCart = [...cart];
    const barangPaket = cart.filter((li) => li.detailBundling.length > 0);
    const barangSatuan = cart.filter((li) => li.detailBundling.length === 0);
    const detailBundling = barangPaket.map((li) => li.detailBundling);
    const totalSatuan = barangSatuan.map((li) => ({ id: li.id, qty: li.qty }));

    const mergedDetailBundling = ([] as DetailBundling[]).concat.apply(
        [],
        detailBundling,
    );

    const bundlingIds: ICart[] = [];
    mergedDetailBundling.forEach((li) => {
        const bundlingId = li.bundlingId;
        const findId = cart.find((c) => c.id === bundlingId);
        if (findId) bundlingIds.push(findId);
    });

    const perkalianQty: IQty[] = [];
    bundlingIds.forEach((_, idx, arr) => {
        perkalianQty.push({
            id: mergedDetailBundling[idx].id,
            qty: arr[idx].qty * mergedDetailBundling[idx].jumlahYangDiambil,
        });
    });

    const totalAllPerkalianQty: IQty[] = [];
    perkalianQty.forEach((x) => {
        const obj = totalAllPerkalianQty.find((o) => o.id === x.id);
        if (obj) obj.qty = obj.qty + x.qty;
        else totalAllPerkalianQty.push(x);
    });

    const grandTotalAll: IQty[] = [];
    totalSatuan.concat(totalAllPerkalianQty).forEach((x) => {
        const obj = grandTotalAll.find((o) => o.id === x.id);
        if (obj) obj.qty = obj.qty + x.qty;
        else grandTotalAll.push(x);
    });

    const indexes: number[] = [];
    grandTotalAll.forEach((_, idx, arr) => {
        const barang = cart.find((li) => li.id === arr[idx].id);
        if (barang) {
            const indexSatuan = cart.findIndex((li) => li.id === barang.id);
            if (indexSatuan || indexSatuan === 0) indexes.push(indexSatuan);
        }
    });

    const res: number[] = [];
    indexes.forEach((idx) => {
        const jumlahDiambil = grandTotalAll.find(
            (li) => li.id === newCart[idx].id,
        )?.qty;
        if (newCart[idx].jumlahStok !== null) {
            res.push(Number(newCart[idx].jumlahStok) - Number(jumlahDiambil));
        }
    });

    const filteredRes = res.filter((li) => li < 0).length;
    const filteredQtyIs0 = cart.filter((li) => li.qty <= 0);

    if (filteredRes > 0) {
        Swal.fire({
            title: "Jumlah pesanan barang melebihi stok",
            position: "top-end",
            showConfirmButton: false,
            icon: "error",
            toast: true,
            timer: 3000,
            timerProgressBar: true,
            showCloseButton: true,
            customClass: { container: "my-swal" },
        });
        return false;
    }

    if (filteredQtyIs0.length > 0) {
        Swal.fire({
            title: "Pesanan tidak boleh kurang 1",
            position: "top-end",
            showConfirmButton: false,
            icon: "error",
            toast: true,
            timer: 5000,
            customClass: { container: "my-swal" },
        });
        return false;
    }

    return true;
}
